import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../baseQuery';

const journalApi = createApi({
  reducerPath: 'journals',
  tagTypes: ['Journal'],
  baseQuery,
  endpoints(builder) {
    return {
      fetchJournals: builder.query({
        providesTags: (result) =>
          result
            ? [
                { type: 'Journal', id: 'LIST' },
                ...result.map((r) => ({ type: 'Journal', id: r.id })),
              ]
            : [{ type: 'Journal', id: 'LIST' }],
        query: () => ({
          url: '?resource=journal',
          method: 'GET',
        }),
      }),

      createJournal: builder.mutation({
        invalidatesTags: [{ type: 'Journal', id: 'LIST' }],
        query: (data) => ({
          url: '?resource=journal',
          method: 'POST',
          body: data,
        }),
      }),

      updateJournal: builder.mutation({
        invalidatesTags: (result, error, { id: journalId }) => [
          { type: 'Journal', id: journalId },
          { type: 'Journal', id: 'LIST' },
        ],
        query: ({ id: journalId, submitData }) => ({
          url: `?resource=journal&id=eq.${journalId}`,
          method: 'PATCH',
          body: submitData,
        }),
      }),

      fetchJournal: builder.query({
        providesTags: (result, error, arg) => [{ type: 'Journal', id: arg }],
        query: (journalId) => ({
          url: `?resource=journal&id=eq.${journalId}`,
          method: 'GET',
        }),
      }),

      fetchJournalByAthlete: builder.query({
        providesTags: (result) =>
          result
            ? [
                { type: 'Journal', id: 'LIST' },
                ...result.map((r) => ({ type: 'Journal', id: r.id })),
              ]
            : [{ type: 'Journal', id: 'LIST' }],
        query: (athleteId) => ({
          url: `?resource=journal&athlete=eq.${athleteId}&order=date.desc`,
          method: 'GET',
        }),
      }),

      fetchJournalByAthleteAndDate: builder.query({
        providesTags: (result) =>
          result
            ? [
                { type: 'Journal', id: 'LIST' },
                ...result.map((r) => ({ type: 'Journal', id: r.id })),
              ]
            : [{ type: 'Journal', id: 'LIST' }],
        query: ({ athleteId, date }) => ({
          url: `?resource=journal&athlete=eq.${athleteId}&date=eq.${date}`,
          method: 'GET',
        }),
      }),

      fetchJournalUserId: builder.query({
        providesTags: (result) =>
          result
            ? [
                { type: 'Journal', id: 'LIST' },
                ...result.map((r) => ({ type: 'Journal', id: r.id })),
              ]
            : [{ type: 'Journal', id: 'LIST' }],
        query: (userId) => ({
          url: `?resource=journal&order=date.desc&select=*,athlete_id:athlete,athlete!inner(*)&athlete.native_user=eq.${userId}`,
          method: 'GET',
        }),
      }),
    };
  },
});

export const {
  useFetchJournalsQuery,
  useCreateJournalMutation,
  useUpdateJournalMutation,
  useFetchJournalQuery,
  useFetchJournalByAthleteQuery,
  useFetchJournalByAthleteAndDateQuery,
  useFetchJournalUserIdQuery,
  useLazyFetchJournalByAthleteAndDateQuery,
} = journalApi;

export { journalApi };
